/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-logs-signpost-custom-waf-latency';
const prefix = `${moduleName}.${componentName}`;

export const latencyLabel = `${prefix}.latencyLabel`;
export const logsNumberLabel = `${prefix}.logsNumberLabel`;

export const ENGLISH = {
    [latencyLabel]: 'Latency (usec)',
    [logsNumberLabel]: '# Logs',
};
